// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app__navbar {
  padding: 1rem 2rem;
  position: fixed; /* Fixiert die Navbar am oberen Bildschirmrand */
  top: 0; /* Positioniert sie oben */
  left: 0; /* Positioniert sie ganz links */
  z-index: 4;
  width: 100%;
}

.app__navbar_links a {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
.app__navbar_hamburgerMenu {
  cursor: pointer;
}

.app__navbar_container-icons {
  display: flex;
  justify-content: space-between;
}
.app__navbar_translateIcon {
  cursor: pointer;
}
.hide {
  display: none;
}
.app__navbar_flaggen {
  border-radius: 10px;
  object-fit: cover;
  min-width: 60px;
  min-height: 40px;
}
.app__navbar_logOut {
  display: flex;
  justify-content: center;
  align-items: center;
}
.app__navbar_logOut-button {
  font-size: 2rem;
  color: var(--color-white);
  font-family: "SawtonCircular-Medium";
  padding-right: 10px;
}
.app__navbar_dashboard-button {
  font-size: 2rem;
  color: var(--color-white);
  font-family: "SawtonCircular-Medium";
  padding-right: 10px;
}
.app__navbar_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: var(--color-blue);
  transition: 0.5s ease;

  flex-direction: column;
  z-index: 5;
}

.app__navbar_overlay .overlay__close {
  font-size: 50px;
  color: #fef4e2;
  cursor: pointer;

  position: absolute;
  top: 20px;
  left: 25px;
}

.app__navbar_links li {
  position: relative;
  margin: 3.5rem 0; /* Nur horizontal Margin */
  cursor: pointer;
  color: var(--color-white);
  font-size: 3rem;
  text-align: center;
  list-style-type: none;
  padding: 0px;
}

.app__navbar_links li::before,
.app__navbar_links li::after {
  content: ""; /* Pseudo-Elemente erstellen */
  position: absolute;
  width: 100%; /* Volle Breite der Liste */
  height: 1px; /* Dicke der Border-Linien */
  background-color: #d4af37; /* Mattes Gold */
  transition: transform 0.3s ease-in-out; /* Sanfte Animation bei Hover */
}

.app__navbar_links li::before {
  top: 0;
  left: 0;
  transform: scaleX(0); /* Startet unsichtbar, keine Breite */
  transform-origin: left; /* Skalierung von links nach rechts */
}

.app__navbar_links li::after {
  bottom: 0;
  right: 0;
  transform: scaleX(0); /* Startet unsichtbar, keine Breite */
  transform-origin: right; /* Skalierung von rechts nach links */
}

.app__navbar_links li:hover::before,
.app__navbar_links li:hover::after {
  transform: scaleX(1); /* Skaliert auf volle Breite bei Hover */
}
@media screen and (max-width: 1440px) {
  .app__navbar_links li {
    margin: 1.45rem 0; /* Nur horizontal Margin */
  }
}

@media screen and (max-width: 1150px) {
  .app__navbar-links {
    display: none;
  }
  .app__navbar_links li {
    margin: 1.5rem 0; /* Nur horizontal Margin */
  }
}

@media screen and (max-width: 650px) {
  .app__navbar {
    padding: 1rem;
  }
  .app__navbar_links li {
    font-size: 2rem;
  }
  .app__navbar_logOut-button {
    font-size: 1.5rem;
  }
  .app__navbar_dashboard-button {
  font-size: 1.5rem;
  
}
}

@media screen and (max-width: 370px) {
  .app__navbar_logOut-button {
    font-size: 1rem;
  }
  .app__navbar_dashboard-button {
  font-size: 1rem;
  
}
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/navbar.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe,EAAE,gDAAgD;EACjE,MAAM,EAAE,0BAA0B;EAClC,OAAO,EAAE,gCAAgC;EACzC,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;;EAErB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;;EAEf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,gBAAgB,EAAE,0BAA0B;EAC5C,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,WAAW,EAAE,8BAA8B;EAC3C,kBAAkB;EAClB,WAAW,EAAE,2BAA2B;EACxC,WAAW,EAAE,4BAA4B;EACzC,yBAAyB,EAAE,gBAAgB;EAC3C,sCAAsC,EAAE,+BAA+B;AACzE;;AAEA;EACE,MAAM;EACN,OAAO;EACP,oBAAoB,EAAE,qCAAqC;EAC3D,sBAAsB,EAAE,qCAAqC;AAC/D;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,oBAAoB,EAAE,qCAAqC;EAC3D,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA;;EAEE,oBAAoB,EAAE,wCAAwC;AAChE;AACA;EACE;IACE,iBAAiB,EAAE,0BAA0B;EAC/C;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB,EAAE,0BAA0B;EAC9C;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;EACA,iBAAiB;;AAEnB;AACA;;AAEA;EACE;IACE,eAAe;EACjB;EACA;EACA,eAAe;;AAEjB;AACA","sourcesContent":[".app__navbar {\r\n  padding: 1rem 2rem;\r\n  position: fixed; /* Fixiert die Navbar am oberen Bildschirmrand */\r\n  top: 0; /* Positioniert sie oben */\r\n  left: 0; /* Positioniert sie ganz links */\r\n  z-index: 4;\r\n  width: 100%;\r\n}\r\n\r\n.app__navbar_links a {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 15px;\r\n}\r\n.app__navbar_hamburgerMenu {\r\n  cursor: pointer;\r\n}\r\n\r\n.app__navbar_container-icons {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.app__navbar_translateIcon {\r\n  cursor: pointer;\r\n}\r\n.hide {\r\n  display: none;\r\n}\r\n.app__navbar_flaggen {\r\n  border-radius: 10px;\r\n  object-fit: cover;\r\n  min-width: 60px;\r\n  min-height: 40px;\r\n}\r\n.app__navbar_logOut {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n.app__navbar_logOut-button {\r\n  font-size: 2rem;\r\n  color: var(--color-white);\r\n  font-family: \"SawtonCircular-Medium\";\r\n  padding-right: 10px;\r\n}\r\n.app__navbar_dashboard-button {\r\n  font-size: 2rem;\r\n  color: var(--color-white);\r\n  font-family: \"SawtonCircular-Medium\";\r\n  padding-right: 10px;\r\n}\r\n.app__navbar_overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100vh;\r\n  background: var(--color-blue);\r\n  transition: 0.5s ease;\r\n\r\n  flex-direction: column;\r\n  z-index: 5;\r\n}\r\n\r\n.app__navbar_overlay .overlay__close {\r\n  font-size: 50px;\r\n  color: #fef4e2;\r\n  cursor: pointer;\r\n\r\n  position: absolute;\r\n  top: 20px;\r\n  left: 25px;\r\n}\r\n\r\n.app__navbar_links li {\r\n  position: relative;\r\n  margin: 3.5rem 0; /* Nur horizontal Margin */\r\n  cursor: pointer;\r\n  color: var(--color-white);\r\n  font-size: 3rem;\r\n  text-align: center;\r\n  list-style-type: none;\r\n  padding: 0px;\r\n}\r\n\r\n.app__navbar_links li::before,\r\n.app__navbar_links li::after {\r\n  content: \"\"; /* Pseudo-Elemente erstellen */\r\n  position: absolute;\r\n  width: 100%; /* Volle Breite der Liste */\r\n  height: 1px; /* Dicke der Border-Linien */\r\n  background-color: #d4af37; /* Mattes Gold */\r\n  transition: transform 0.3s ease-in-out; /* Sanfte Animation bei Hover */\r\n}\r\n\r\n.app__navbar_links li::before {\r\n  top: 0;\r\n  left: 0;\r\n  transform: scaleX(0); /* Startet unsichtbar, keine Breite */\r\n  transform-origin: left; /* Skalierung von links nach rechts */\r\n}\r\n\r\n.app__navbar_links li::after {\r\n  bottom: 0;\r\n  right: 0;\r\n  transform: scaleX(0); /* Startet unsichtbar, keine Breite */\r\n  transform-origin: right; /* Skalierung von rechts nach links */\r\n}\r\n\r\n.app__navbar_links li:hover::before,\r\n.app__navbar_links li:hover::after {\r\n  transform: scaleX(1); /* Skaliert auf volle Breite bei Hover */\r\n}\r\n@media screen and (max-width: 1440px) {\r\n  .app__navbar_links li {\r\n    margin: 1.45rem 0; /* Nur horizontal Margin */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1150px) {\r\n  .app__navbar-links {\r\n    display: none;\r\n  }\r\n  .app__navbar_links li {\r\n    margin: 1.5rem 0; /* Nur horizontal Margin */\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 650px) {\r\n  .app__navbar {\r\n    padding: 1rem;\r\n  }\r\n  .app__navbar_links li {\r\n    font-size: 2rem;\r\n  }\r\n  .app__navbar_logOut-button {\r\n    font-size: 1.5rem;\r\n  }\r\n  .app__navbar_dashboard-button {\r\n  font-size: 1.5rem;\r\n  \r\n}\r\n}\r\n\r\n@media screen and (max-width: 370px) {\r\n  .app__navbar_logOut-button {\r\n    font-size: 1rem;\r\n  }\r\n  .app__navbar_dashboard-button {\r\n  font-size: 1rem;\r\n  \r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
